import { useSessionContext } from '@common/hooks';
import { CampagneDto } from '@common/services';
import { CampagneSelect } from '@common/ui';
import React from 'react';

export const OfaCampagneSelect = ({ onYearChange }: OfaCampagneSelectProps) => {
  const { accessHistory } = useSessionContext();

  const campagnes = accessHistory.reduce<Pick<CampagneDto, 'annee' | 'statut'>[]>((acc, access) => {
    // On n'affiche qu'une seule année de campagne
    // Donc si un organisme a été refusé plusieurs fois pendant une campagne, seul le dernier est lié à la campagne affichée
    // (cette condition suffit au vu du tri sur accessHistory)
    if (acc.find(a => a.annee === access.campagneAnnee)) return acc;

    acc.push({
      annee: access.campagneAnnee,
      statut: access.campagneStatut,
    });

    return acc;
  }, []);


  return (
    <CampagneSelect campagnes={campagnes} onYearChange={onYearChange} />
  );
};

interface OfaCampagneSelectProps {
  onYearChange?: (year: number) => void;
}